import React from "react";
import { ART_STYLES } from "@/lib/styles";

// Reusable "🎨 Choose a style" picker. Pass value (style id) + onChange.
// `compact` renders smaller chips for tight panels (e.g. the game builder).
export function StylePicker({ value, onChange, testid = "style-picker", compact = false, label = "Choose a style" }) {
  return (
    <div data-testid={testid}>
      <div className={`font-bold mb-1.5 flex items-center gap-1.5 ${compact ? "text-[11px]" : "text-sm"}`}>
        <span>🎨</span> {label}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {ART_STYLES.map((s) => {
          const on = value === s.id;
          return (
            <button
              key={s.id}
              type="button"
              onClick={() => onChange(s.id)}
              data-testid={`style-${s.id}`}
              title={s.hint}
              className={`inline-flex items-center gap-1.5 rounded-full border font-semibold transition-all ${compact ? "pl-1 pr-2.5 py-0.5 text-[11px]" : "pl-1.5 pr-3 py-1 text-xs"} ${
                on
                  ? "border-[hsl(var(--primary))] bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))] shadow-sm"
                  : "border-[hsl(var(--border))] hover:border-[hsl(var(--primary))]/50 hover:bg-[hsl(var(--primary))]/5"
              }`}
            >
              <span className={`rounded-full ring-1 ring-black/10 ${compact ? "w-3.5 h-3.5" : "w-4 h-4"}`} style={{ background: s.swatch }} />
              {s.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default StylePicker;
